export const DEFAULT_PRIORITY_COUNTS = { P0: 0, P1: 0, P2: 0, P3: 0 };

export const EMPTY_INBOX_SELECTED_FILTERS = {
  primary_category: [],
  urgency_level: [],
  resolution_status: [],
  priority: [],
  emotions: []
};

export const INBOX_ITEMS_PER_PAGE = 25;
export const MAX_INBOX_SCAN_PAGES = 8;
